export const borderWidths = [0, 1, 2]
export const radii = {
  none: 0,
  xs: 2,
  sm: 4,
  md: 8,
  full: 9999,
}
